import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class ChargeServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
}

export const ChargeService = new ChargeServiceClass({
  api_version: 2,
  resource: 'referrals/charges'
});
